import gql from 'graphql-tag';

export const GET_COMPANIES_PARTNERS = gql`
  query Partners {
    getCompaniesPartners {
      id
      title
      description
      image_url
      url_text
      url_link
    }
  }
`;

export const GET_PARTNERS_TYPES = gql`
  query PartnersTypes {
    listPartnerTypes {
      id
      name
    }
  }
`;

export const GET_PARTNER_BY_ID = gql`
  query PartnerById($id: Number!) {
    getPartner(id: $id) {
      id
      title
      description
      image_url
    }
  }
`;

export const GET_LIST_PARTNERS_BY_FILTER = gql`
  query PartnersByType($filter: PartnerSearchFilter) {
    listPartners(filter: $filter) {
      id
      title
      description
      image_url
    }
  }
`;
